import React from 'react'
import { compose } from 'recompose'
import { useSelector, useDispatch } from 'react-redux'

import withRouterActions from 'routes/utils/withRouterActions'
import { enableDetachedMode } from 'data/ui/actions'
import { trackNoteClicked } from 'data/analytics/actions'
import RoutesHelper from 'helpers/RoutesHelper'
import { getActiveChannelId } from 'data/ui/selectors'
import { getNote } from 'data/notes/selectors'
import { isAppDesktop } from 'helpers/DesktopHelpers'

function getRedirectURL({ channelId, noteId, blockId }) {
  const destinationParams = {
    noteId,
    channelId,
    blockId,
  }
  return channelId
    ? RoutesHelper.noteChannelShow(destinationParams)
    : RoutesHelper.noteShow(destinationParams)
}

export default ({ NoteLinkPlugin, trackingSource = 'notelink' }) => ({
  decorator = x => x,
} = {}) => {
  const noteLinkDecorator = DecoratedComponent =>
    function NoteLinkDecorated(props) {
      const { noteId, blockId, routerPush } = props

      const dispatch = useDispatch()
      const activeChannelId = useSelector(getActiveChannelId)
      const note = useSelector(state => getNote(state, noteId))

      const channelId = (note && note.channelId) || activeChannelId
      const url = getRedirectURL({ channelId, noteId, blockId })

      const onClick = React.useCallback(
        () => {
          dispatch(trackNoteClicked({ source: trackingSource }))
          routerPush(url)
        },
        [routerPush, dispatch, url]
      )

      const onMetaClick = React.useCallback(
        () => {
          if (isAppDesktop()) {
            dispatch(enableDetachedMode({ noteId }))
          } else {
            window.open(url, '_blank')
          }
        },
        [dispatch, noteId, url]
      )

      return (
        <DecoratedComponent
          {...props}
          url={url}
          onClick={onClick}
          onMetaClick={onMetaClick}
        />
      )
    }

  return NoteLinkPlugin({
    isPublic: false,
    decorator: compose(
      decorator,
      withRouterActions,
      noteLinkDecorator
    ),
  })
}
